import React from 'react';
import { views } from './constants';
import List from './List';

export default function ResearcherList() {
  return <List view={views.researchers} />;
}
